import React from 'react';
import { ICON_PH } from '../../data/homeData';

/* Level-2 tabs (.new_icasino_tabs): each tab stacks a 28px int_tab_icons image
   (sepia-grey; inverted-white when active) ABOVE a capitalized label. The tab <a>
   is flex-direction:column (supplement) so the img + label span stack vertically. */
export default function SubTabs({ subtabs, active, onChange, children }) {
  return (
    <div className="casino_tabs_ul tab-container">
      <ul role="tablist" className="nav nav-tab new_icasino_tabs mt-2" aria-label="Tabs">
        {subtabs.map((st, i) => {
          const on = i === active;
          return (
            <li className={on ? 'active nav-item' : 'nav-item'} key={st.key}>
              <a
                href="javascript:void(0);"
                role="tab"
                aria-selected={on}
                className={on ? 'nav-link active' : 'nav-link'}
                onClick={(e) => { e.preventDefault(); onChange(i); }}
              >
                <img
                  className="img-fluid"
                  src={st.icon}
                  alt=""
                  onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = ICON_PH; }}
                />
                <span>{st.label}</span>
              </a>
            </li>
          );
        })}
      </ul>
      {/* game grid tab-content nested INSIDE .casino_tabs_ul (matches the height:120px rule) */}
      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active">{children}</div>
      </div>
    </div>
  );
}
